import React, { useContext } from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const sortByName = (data) => {
  return Object.entries(data).sort((a, b) => {
    if (a[1] < b[1]) return -1;
    if (a[1] > b[1]) return 1;
    return 0;
  });
}

const sortByKey = (data) => {
  return Object.entries(data).sort((a, b) => {
    if (Number(a[0]) < Number(b[0])) return -1;
    if (Number(a[0]) > Number(b[0])) return 1;
    return 0;
  });
}

const readParamsArray = (values, choices) => {
  var ret = {}
  if(typeof values === 'string'){
    const arr = values.split(',')
    for(const key in choices){
      ret[key] = (arr.indexOf(key) !== -1)
    }
  }
  else return values
  return ret
}

const MultiInput = ({ source, updateData, ParamContext }) => {
  const { setParams, data } = useContext(ParamContext)
  const params = data.params.fields.find((el)=>el.name === source)
  
  const getDefaultValue = (def = false) => {
    if(data.params.values && typeof data.params.values[source] !== 'undefined'){
      return data.params.values[source]
    }
    else if(data.params.values && typeof data.params.values[params?.legacyname] !== 'undefined'){
      return data.params.values[params?.legacyname]
    }
    else if(typeof params?.default !== 'undefined'){
      return params?.default
    }
    else {
      return def
    }
  }
  const value = getDefaultValue()
  const value2 = (data.params.values && typeof data.params.values[params?.name2] !== 'undefined')?data.params.values[params?.name2]:params?.default2
  const valueBool = getDefaultValue()==='1'?true:false
  const valueArr = params?.type==='multiSelect'?readParamsArray(getDefaultValue(), params?.choices):[]

//console.log([data, params, value, valueArr, valueBool])

  if(!params || !params.name || value === null )return null
  
  const updateParamValue = (key, value) => {
    const p = {...data.params}
    p.values[key] = value
    updateData({...data, params: p })
    setParams( JSON.stringify(p.values) )
  }
  
  if(!source)return null;
  var field1 = params.text;
  var field2 = '';
  var field3 = '';
  var field4 = '';
  var field5 = '';
  var width = [2,3,3,2,2]
  var cstyle = {width:'100%'};
  var gstyle = [{alignContent:'center'},{alignContent:'center'},{alignContent:'center'},{alignContent:'center'},{alignContent:'center'}];
  const choices = []
  var SChoices = {}
  if(params.width)width = params.width
  switch(params.type) {
    case 'title':
      field1 = <b style={{marginBottom: "1em"}}>{field1}</b>;
      cstyle = {...cstyle, ...{height:'2em'}};
      break;
    case 'space':
      field1 = <div> </div>;
      cstyle = {...cstyle, ...{height:'2em'}};
      break;
    case 'line':
      field1 = <hr />;
      cstyle = {...cstyle, ...{height:'2em'}};
      break;
    case 'value':
      field2 = value
      cstyle = {...cstyle, ...{marginTop:'1em'}};
      break;
    case 'link':
      field1 = <a href={params.default} target="_blank" rel="noreferrer">{params.text}</a>
      cstyle = {...cstyle, ...{marginTop:'1em'}};
      break;
    case 'text':
    case 'number':
      field2 = <TextField label={false} value={value} size="small" variant="outlined" sx={{ minWidth: '6em'}} onChange={(ev)=>{updateParamValue(source, ev.target.value)}} />;
      if(params.text2)field3 = params.text2
      break;
    case 'time':
      width = [2,1,2,3,4]
      field2 = <TextField label={false} value={value} size="small" variant="outlined" sx={{ minWidth: '6em', width: '95%'}} onChange={(ev)=>{updateParamValue(source, ev.target.value)}} />;
      if(params.text2)field3 = params.text2
      break;
    case 'textDouble':
      field2 = <TextField label={false} value={value} size="small" variant="outlined" sx={{ minWidth: '6em'}} onChange={(ev)=>{updateParamValue(source, ev.target.value)}} />
      if(params.text2)field3 = params.text2
      field4 = <TextField label={false} value={value2} size="small" variant="outlined" sx={{ minWidth: '6em'}} onChange={(ev)=>{updateParamValue(params.name2, ev.target.value)}} />
      if(params.text3)field5 = params.text3
      break;
    case 'checkbox':
      field2 = <Checkbox checked={valueBool} onChange={(ev)=>{updateParamValue(source, ev.target.checked===true?'1':'0');}} />;
      if(params.text2)field3 = params.text2
      break;
    case 'select':
      if(params.ksort){
        SChoices = sortByKey(params.choices)
      }
      else {
        SChoices = sortByName(params.choices)
      }
      for(const key in SChoices){
        choices.push(<MenuItem key={key} value={SChoices[key][0]}>{SChoices[key][1]}</MenuItem>)
      }
      field2 = <Select size="small" sx={{ minWidth: '6em', width: '100%'}} label={false} value={value} onChange={(ev)=>{updateParamValue(source, ev.target.value)}} >{choices}</Select>;
      if(params.text2)field3 = params.text2
      break;
    case 'selectDouble':
      const choices2 = []
      width = [2,2,1,3,4]
      if(params.ksort){
        SChoices = sortByKey(params.choices)
      }
      else {
        SChoices = sortByName(params.choices)
      }
      for(const key in SChoices){
        choices.push(<MenuItem key={'sel1'+key+source} value={SChoices[key][0]}>{SChoices[key][1]}</MenuItem>)
      }
      if(params.ksort){
        SChoices = sortByKey(params.choices2)
      }
      else {
        SChoices = sortByName(params.choices2)
      }
      for(const key in SChoices){
        choices2.push(<MenuItem key={'sel2'+key+source} value={SChoices[key][0]}>{SChoices[key][1]}</MenuItem>)
      }
      field2 = <Select size="small" sx={{minWidth: '8em', width: '100%'}} label={false} value={value} onChange={(ev)=>{updateParamValue(source, ev.target.value)}} >{choices}</Select>;
      field3 = <Select size="small" sx={{minWidth: '8em'}} label={false} value={value2} onChange={(ev)=>{updateParamValue(params.name2, ev.target.value)}} >{choices2}</Select>;
      break;
    case 'multiSelect':
      for(const key in params.choices){
        choices.push(
          <span key={key}>
            <Checkbox checked={valueArr[key]} onChange={(ev)=>{const varr = {...valueArr};varr[key] = ev.target.checked;updateParamValue(source, varr);}} />
            {params.choices[key]}
          </span>
        )
        field2 = <div style={{display:'grid'}}>{choices}</div>
      }
      break;
    default:
      break;
  }
  if(!field2 && params.type !== 'title' && params.type !== 'space' && params.type !== 'line' && params.type !== 'value' && params.type !== 'link')return null;
  if(params.style){
    for(const key in params.style){
      if(typeof params.style[key] === 'object'){
        for(const skey in params.style[key]){
          gstyle[key][skey] = params.style[key][skey]
        }
      }
    }
  }
  return (
    <Grid container style={cstyle}>
      <Grid item xs={12} md={width[0]} sx={gstyle[0]}>{field1}</Grid>
      <Grid item xs={12} md={width[1]} sx={gstyle[1]}>{field2}</Grid>
      <Grid item xs={12} md={width[2]} sx={gstyle[2]}>{field3}</Grid>
      <Grid item xs={12} md={width[3]} sx={gstyle[3]}>{field4}</Grid>
      <Grid item xs={12} md={width[4]} sx={gstyle[4]}>{field5}</Grid>
    </Grid>
  )
}

export default MultiInput